"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../../core/button"));
var _modal = _interopRequireDefault(require("../../../../../core/modal"));
var _offerHistory = _interopRequireDefault(require("./offer-history"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // This allows user to retract the offer of a place.
var _ref = /*#__PURE__*/_react.default.createElement("div", {
  className: "col-xs-12"
}, /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "If you retract this offer the paddler will no longer be able to pay online and you may offer the place to another paddler."), /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "Their details will remain on the waiting list and you can re-offer a place to send a reminder message with a shorter time allowance"));
class RetractOfferModal extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onConfirmRetractOffer", () => {
      this.props.onUpdate(this.props.entry.id, 'canEnterFromWaitingList', false);
      this.props.onToggleRetractOffer();
    });
  }
  render() {
    const entry = this.props.entry;
    const today = new Date().toISOString().split('T')[0];
    const modalButtons = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this.props.onToggleRetractOffer
    }, "Cancel"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onConfirmRetractOffer,
      type: "primary"
    }, "Confirm Retract Offer"));
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: "Retract offer of place and prevent online payment",
      buttons: modalButtons,
      onClose: this.props.onToggleRetractOffer
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/_react.default.createElement(_offerHistory.default, {
      entry: this.props.entry
    })), _ref));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref2 = _mergeBqlQueries({
  id: true
}, _offerHistory.default.partialQueries.Entry);
var _default = exports.default = (0, _reactBicycle.connect)(RetractOfferModal, props => ({
  ["entry(entryID:" + JSON.stringify(props.entryID) + ")"]: _ref2
}), (client, props) => ({
  onUpdate(id, field, value) {
    return client.update('Entry.set', {
      id,
      field,
      value
    });
  }
}));